import ClockoutController from '../../core/clockout.controller';
import Inherit from '../../core/inherit';
import BillingDelegate from './billing.delegate';

class BillingController extends Inherit(ClockoutController, BillingDelegate) {
    state = {
        user: {},
        loading: true,
        kpiData: null,
        kpiLoaded: false,
        statements: [],
        statementsLoaded: false,
        dateRange: null,
        selectedStatements: new Set(),
    };

    async initialize() {
        if (!this.user?.access?.length) {
            this.navigateLogin();
            return;
        }

        this.setState({ loading: true, user: this.data.user });

        // Load all data
        await this.loadAllData();
        
        this.setState({ loading: false });
    }

    async loadAllData() {
        // Individual API calls with separate state updates for progressive loading
        try {
            this.data.fetchBillingKPIs()
                .then(kpiData => this.setState({ kpiData, kpiLoaded: true }))
                .catch(() => {
                    // Mock data fallback
                    this.setState({
                        kpiData: {
                            enrolledUsers: 1000,
                            enrolledUsersChange: 20,
                            invoiceAmount: 3000.00,
                            invoiceAmountChange: 20,
                            nextInvoiceDue: 'Dec 30, 2025',
                            nextInvoiceDueChange: 20
                        },
                        kpiLoaded: true
                    });
                });

            this.data.fetchBillingStatements()
                .then(statements => this.setState({ statements, statementsLoaded: true }))
                .catch(() => {
                    // Mock data fallback
                    this.setState({
                        statements: [
                            { id: 1, dateRange: 'Nov 1 - Nov 30, 2025', enrolledUsers: 1000, invoiceAmount: 3000.00, status: 'Overdue' },
                            { id: 2, dateRange: 'Oct 1 - Oct 30, 2025', enrolledUsers: 900, invoiceAmount: 2700.00, status: 'Paid' },
                            { id: 3, dateRange: 'Sep 1 - Sep 30, 2025', enrolledUsers: 800, invoiceAmount: 2700.00, status: 'Pending' },
                            { id: 4, dateRange: 'Aug 1 - Aug 30, 2025', enrolledUsers: 700, invoiceAmount: 2700.00, status: 'Pending' },
                            { id: 5, dateRange: 'Jul 1 - Jul 30, 2025', enrolledUsers: 600, invoiceAmount: 2700.00, status: 'Pending' },
                            { id: 6, dateRange: 'Jun 1 - Jun 30, 2025', enrolledUsers: 500, invoiceAmount: 2700.00, status: 'Pending' },
                        ],
                        statementsLoaded: true
                    });
                });
        } catch (error) {
            console.error('Error loading billing data:', error);
        }
    }

    async loadDataWithDateRange(startDate, endDate) {
        // Reload data with date filters
        const start = startDate.format('YYYY-MM-DD');
        const end = endDate.format('YYYY-MM-DD');

        try {
            this.data.fetchBillingKPIs(start, end)
                .then(kpiData => this.setState({ kpiData }))
                .catch(console.error);

            this.data.fetchBillingStatements(start, end)
                .then(statements => this.setState({ statements }))
                .catch(console.error);
        } catch (error) {
            console.error('Error loading billing data with date range:', error);
        }
    }

    async exportToXLSX() {
        try {
            const { selectedStatements, statements } = this.state;
            const statementIds = selectedStatements.size > 0 
                ? Array.from(selectedStatements) 
                : statements.map(s => s.id);
            
            await this.data.exportBillingStatements(statementIds);
        } catch (error) {
            console.error('Error exporting statements:', error);
        }
    }
}

export default BillingController;

